import { Component, ChangeDetectionStrategy } from '@angular/core';
import {CarrierFtpInfo, UsersInsuranceService} from '../../../services/usersinsurance/users.insurance.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-carrierftpdialog',
    templateUrl: './carrierftpdialog.component.html',
    styleUrls: ['./carrierftpdialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrierftpdialogComponent {

  protected ftpProducts: CarrierFtpInfo = [];
  protected selectedProducts = [];

  constructor(
      private usersInsuranceService: UsersInsuranceService,
      public dialogRef: MatDialogRef<CarrierftpdialogComponent>,
  ) {
    this.usersInsuranceService.getCarrierFtpInfo().then(result => {
      this.ftpProducts = result;
    });
  }

  setProduct(event: any): void {
    this.selectedProducts = event.value;
    console.log(event);
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedProducts);
  }

  onDismiss(): void {
    this.dialogRef.close(null);
  }
}

export class CarrierftpDialogModel {
  constructor() {

  }
}
